import React, { FC, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { MultiselectFiltersConfigItem } from '@hkm/components/TaskManagement/Dashboard/config/multiselectFiltersConfig';
import { getDashboardQuickFilter } from '@hkm/components/TaskManagement/Dashboard/domain/selectors';

import { AcMultiSelect } from '@ac/mobile-components/dist/components/multiselect';

interface ComponentProps {
  filterItem: MultiselectFiltersConfigItem;
}

const MultiselectFilterItem: FC<ComponentProps> = props => {
  const { filterItem } = props;
  const { t } = useTranslation();
  const currentQuickFilter = useSelector(getDashboardQuickFilter);

  const disabled = useMemo(
    () =>
      filterItem.relatedQuickFilters?.length
        ? filterItem.relatedQuickFilters!.some(
            field => field === currentQuickFilter
          )
        : false,
    [currentQuickFilter, filterItem.relatedQuickFilters]
  );

  return (
    <AcMultiSelect
      className="ac-spacing-top-md"
      label={filterItem.label}
      placeholder={t('GLOBAL.SELECT')}
      disabled={disabled}
      selectedItem={filterItem.value || []}
      itemsList={filterItem.options}
      showInputs={true}
      testSelector={`task-management-filter-${filterItem.name}`}
      onChange={filterItem.updateValue}
    />
  );
};

export default memo(MultiselectFilterItem);



// WEBPACK FOOTER //
// ./src/components/TaskManagement/Dashboard/DashboardFilters/DashboardFiltersBody/MultiselectFilterItem/MultiselectFilterItem.tsx